import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsLoadingHOC from "../common/IsLoadingHOC";
import { authAxios } from "../config/config";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BlogsHelper } from "../helper/helper";
import { setrefetch } from "../Redux/Reducers/authSlice";

const BlogPage = (props) => {
  const { setLoading } = props;
  const navigate = useNavigate()
  const userName = useSelector((state) => state.auth.user.fname);
  const location = useLocation();
  const ids = location?.state?.id;
  const [formValues, setFormValues] = useState({
    Title: "",
    Topic: "",
    Introduction: "",
    Main_Points: "",
    Examples_or_Case_Studies: "",
    Conclusion: "",
    Call_to_Action: "",
    Quotes: "",
  });
  const dispatch = useDispatch()

  const [storyDetail, setstoryDetail] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const endpoint = editable ? 'blog/editBlogRelase' : 'blog/submit_form';
    
    const payload = {
      Title: formValues.Title || "",
      Topic: formValues.Topic || "",
      Introduction: formValues.Introduction || "",
      Main_Points: formValues.Main_Points || "",
      Examples_or_Case_Studies: formValues.Examples_or_Case_Studies || "",
      Conclusion: formValues.Conclusion || "",
      Call_to_Action: formValues.Call_to_Action || "",
      Quotes: formValues.Quotes || "",
      ...(editable && { _id: storyId })
    };
    try {
      const response = await authAxios().post(endpoint, payload);
      const resData = response?.data;
      setstoryDetail(resData.data);
      dispatch(setrefetch("blogs"))
      toast.success(resData?.message);
      
      sessionStorage.removeItem("editable")
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const editable = sessionStorage.getItem("editable");
  const storyId = sessionStorage.getItem("story_id");

  const fetchstory = async () => {
    setLoading(true);
    await authAxios()
      .post(`/blog/getsBlogRelase`, { _id: storyId })
      .then((response) => {
        setLoading(false);
        const data = response?.data?.data;

        setFormValues((prevValues) => ({
          ...prevValues,
          ...data,
        }));

        setstoryDetail(data);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };
  useEffect(() => {
    if (storyId) {
      fetchstory();
    }
  }, [storyId]);

  useEffect(() => {
    sessionStorage.removeItem("editable");
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleback =()=>{
    sessionStorage.removeItem("story_id");
    sessionStorage.removeItem("formType");
  navigate("/")

  }
  return (
    <>
      <div className="h-full flex flex-col justify-between">
        <div>
          <style>
            {`
              .custom-scrollbar::-webkit-scrollbar {
                width: 10px;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb {
                background: #FAF4CE;
                border-radius: 10px;
              }
            `}
          </style>

          <div
            className={`py-[20px] overflow-auto h-[calc(100vh-100px)] pb-[35px] custom-scrollbar`}
          >
            <div className="bg-[#FAF4CE] border-[2px] border-[#EAB14D] p-[15px] rounded-[10px] flex items-center gap-5 max-w-[885px] w-full mx-auto mb-5">
              <div>
                <img
                  src="./assets/images/press-c.png"
                  alt="image"
                  className="w-[65px] aspect-square"
                  onClick={handleback}
                />
              </div>
              <p className="text-[#2C2C2C] text-[20px] font-semibold">
                Write your Blog
              </p>
            </div>

            <div className="max-w-[885px] w-full mx-auto">
              <div className="bg-[#FAF4CE] rounded-t-[10px] min-h-[88px] text-center p-[20px] flex items-center justify-center border-b-[2px] border-b-[#fff]">
                <h1 className="text-[#000] lg:text-[40px] font-[600] text-[25px]">
                  Welcome <span className="capitalize">{userName}!</span>
                </h1>
              </div>

              <form
                onSubmit={handleSubmit}
                className="bg-[#FAF4CE] lg:p-[40px] p-[15px] lg:pb-[10px] rounded-b-[10px]"
              >
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="businessName"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                     What is the topic of your blog?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      type="text"
                      name="Title"
                      value={formValues.Title}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                      disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What specific issues will your blog focus on?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Topic"
                      value={formValues.Topic}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      How will you introduce the main subject of your blog to engage readers?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Introduction"
                      value={formValues.Introduction}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      // className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What are the key points or arguments you want to cover in your blog?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Main_Points"
                      value={formValues.Main_Points}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      // className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Are there any specific examples or case studies that will support your points?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Examples_or_Case_Studies"
                      value={formValues.Examples_or_Case_Studies}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="businessIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      How will you summarize the main points of your blog in the conclusion?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Conclusion"
                      value={formValues.Conclusion}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What action do you want your readers to take after reading your blog? <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Call_to_Action"
                      value={formValues.Call_to_Action}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Are there any notable quotes or statements from experts that will be included?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Quotes"
                      value={formValues.Quotes}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                {storyDetail?.story ? (
                  <>
                  <div className="flex flex-col lg:flex-row gap-3 mb-3 bg-white p-5 rounded-[10px]">
                    <div className="w-full flex flex-col gap-y-[10px]">
                        {BlogsHelper(storyDetail?.story)}
                    </div>
                  </div>
                  {editable && 
                  <div className="flex justify-center py-3">
                    <button
                  type="submit"
                  className="bg-[#EAB14D] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                >
                  Regenerate
                </button>
                </div>}
                  </>
                ) : (
                  <div className="flex justify-center py-3">
                    <button
                      type="submit"
                      className="bg-[#EAB14D] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                    >
                      Submit
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IsLoadingHOC(BlogPage);
